export default {
  /**
   * Helper methods for making HTTP requests.
   *
   * HTTP requests are as follows POST|PUT|PATCH|DELETE.
   */
  post(uri, form, config = {}) {
    return Spark.sendForm("post", uri, form, config);
  },
  put(uri, form, config = {}) {
    return Spark.sendForm("put", uri, form, config);
  },
  patch(uri, form, config = {}) {
    return Spark.sendForm("patch", uri, form, config);
  },
  delete(uri, form, config = {}) {
    return Spark.sendForm("delete", uri, form, config);
  },

  /**
   * Send the form to the back-end server.
   *
   * This function will clear old errors, update "busy" status, etc.
   */
  sendForm(method, uri, form, config) {
    return new Promise((resolve, reject) => {
      form.startProcessing();

      axios[method](uri, JSON.parse(JSON.stringify(form)), config)
        .then((response) => {
          form.finishProcessing();

          resolve(response.data);
        })
        .catch((errors) => {
          form.setErrors(errors.response?.data.errors);

          reject(errors.response?.data ?? errors.message);
        });
    });
  },
};
